import { QueriesSearchParams } from '../../utils/lpr.utils';

export interface DefaultFsBbox {
  defaultFsBbox: string;
}

export interface ILprExportParamsInterface {
  searchReason?: string;
  fromDate?: Date;
  toDate?: Date;
  plate?: string;
  plateState?: string;
  vehicleColor?: string[];
  vehicleMake?: string;
  vehicleBody?: string;
  vehicleName?: string;
  recordType?: string;
  assignedUserIds?: string[];
  deviceNames?: string[];
  caseNumber?: string;
  inBbox?: QueriesSearchParams | DefaultFsBbox;
}
